import React, { useContext } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import {
  ROUTE_EXERCISES_TRAININGS_ENTITY,
  ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING,
  ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES
} from 'routes/RouteList';
import useSelectable from 'hooks/utils/useSelectable';
import { useStore } from 'stores/Store';
import useTrainings from 'hooks/queries/useTrainings';
import FieldInput from 'components/input/FieldInput';
import { List, ListBody } from 'components/list';
import TemplatesListItem from 'containers/partials/list-items/TemplatesListItem';
import { Card, CardBody } from 'components/card';
import Message from 'components/message/Message';
import MessageText from 'components/message/MessageText';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import { StoreContext } from 'index';

const TrainingsTab = () => {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { push } = useHistory();
  const { entityId, templateId } = useParams();
  const { selected, select } = useSelectable([]);
  const trainings = useStore(state => state.trainings);
  const { filterTrainings } = useTrainings(entityId, user);
  const onSearch = async e => {
    filterTrainings({ search: e.target.value });
  };

  const onClickHandler = training => {
    push(
      generatePath(ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING_EXERCISES, {
        entityId,
        templateId: training.id
      })
    );
  };

  const onEditHandler = training => {
    push(
      generatePath(ROUTE_EXERCISES_TRAININGS_ENTITY_TRAINING, {
        entityId,
        templateId: training.id
      })
    );
  };

  const onDeleteHandler = templateId => {
    push(
      generatePath(ROUTE_EXERCISES_TRAININGS_ENTITY, {
        entityId,
        templateId
      })
    );
  };

  return (
    <>
      <FieldInput rounded icon="search-grey" iconLeft onChange={onSearch} />
      {trainings && trainings.length ? (
        <List>
          {/* <ListHeader noTitleStatus>
                <ListColumnTitle
                // ascendent // in comment totdat het werkt:
                // TODO: rangschikking list by column title
                >
                  <FormattedMessage
                    {...messages.trainingsHeaderListTrainings}
                  />
                </ListColumnTitle>
                <ListColumnTitle>
                  <FormattedMessage
                    {...messages.trainingsHeaderListExercisesQty}
                  />
                </ListColumnTitle>
              </ListHeader> */}
          <ListBody>
            {trainings.map(training => (
              <TemplatesListItem
                checkbox={false}
                icon="program"
                mediumIcon
                visible={selected.length > 0}
                exercisesLength={training.exercises.length}
                id={training.id}
                key={training.id}
                template={training}
                entityId={entityId}
                active={training.id === templateId}
                checked={selected.includes(training.id)}
                onChange={() => select(training.id)}
                onClick={() => {
                  return onClickHandler(training);
                }}
                onEdit={() => onEditHandler(training)}
                onDeleted={() => onDeleteHandler(templateId)}
              />
            ))}
          </ListBody>
        </List>
      ) : (
        <EmptyTrainingList />
      )}
    </>
  );
};

export default TrainingsTab;

const EmptyTrainingList = () => (
  <Card centered>
    <CardBody empty>
      <Message emptyState={true} icon="browse">
        <MessageText>
          <FormattedMessage {...messages.templateListEmpty} />
        </MessageText>
      </Message>
    </CardBody>
  </Card>
);
